import { createRatesService } from './rate.service';

const ENDPOINT = '/api/credit_rates';
const CreditRateService = createRatesService(ENDPOINT, 'credit_rate');

export default CreditRateService;